import styled, { createGlobalStyle } from "styled-components";
import { ColorProps, GlobalColorPalette, ITable } from "@gago/frame";
import filterIcon from "./images/fliter.svg";
import { Marker } from "@gago-react-gl/gago-react-gl";

// tslint:disable:variable-name
export const VillageScreenBody = styled.div<ColorProps<GlobalColorPalette>>`
  height: 100%;
  width: 100%;
  .header-box{
    height: 92px;
    width: 100%;
    background-color: #09131f;
    background-image: url("/static/images/header-top-2.png");
    background-repeat: no-repeat;
    background-size: contain;
  }
  .village-body{
    height: calc(100% - 92px);
    width: 100%;
    padding: 16px;
    padding-top: 0px;
    display: flex;
    justify-content: flex-start;
    .asider-left{
      flex: 1 0 auto;
      width: 460px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .chart-box{
        flex: 1 1 auto;
        margin-top: 16px;
        &:first-of-type{
          margin-top: 0px;
        }
      }
      .h-128{
        height: 128px;
      }
      .h-196{
        height: 194px;
      }
      .right-height{
        height: 25%;
      }
    }
    .content-middle{
      padding: 16px;
      padding-bottom: 0;
      flex: 2 2 auto;
      width: 920px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .mapbox-border{
        height: 706px;
        flex: 2 2 auto;
        position: relative;
        .cmb-select{
          position: absolute;
          top: 8px;
          left: 0;
          padding: 0;
          z-index: 99;
        }
        .back-box{
          position: absolute;
          top: 8px;
          right: 0px;
          z-index: 99;
          cursor: pointer;
          user-select: none;
          width: 40px;
          height: 50px;
          border-radius: 6px;
          border: solid 1px 1px solid rgb(0 202 224 / 45%);
          color: #00cae0;
          font-size: 12px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transition: all 0.25s ease-out;
          background-color: #122B45;
          &:hover{
            box-shadow: 0 0 6px rgb(0 202 224 / 80%);
          }
        }
        .map-border{
          height: calc(100% - 62px);
          width: 100%;
          position: relative;
          margin-top: 62px;
          overflow: hidden;
        }
        .react-mapbox--container{
          .mapboxgl-canvas{
            outline: none;
            overflow: hidden;
          }
        }
        .timeline-box{
          position: absolute;
          bottom: 0px;
          left: 16px;
          right: 16px;
          display: flex;
          justify-content: center;
        }
      }
      .chart-box{
        height: 232px;
        flex: 1 1 auto;
        margin-top: 16px;
      }
    }
    .resource-box{
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .resource-single{
        margin-right: 4px;
        flex: 1 1 auto;
        width: 30%;
        &:last-of-type{
          margin-right: 0px;
        }
      }
    }
    .internet-thing-chart{
      .screen-card-content{
        overflow: unset;
      }
      .internet-thing{
        position: absolute;
        left: 0;
        top: -20px;
        height: 24px;
        width: 100%;
        padding-left: 122px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .it-left-box{
          display: flex;
          align-items: center;
          .itlb-value{
            line-height: 1;
            height: 24px;
            display: flex;
            align-items: center;
            .itlb-f{
              font-size: 14px;
              color: #00cae0;
            }
            .itlb-s{
              font-size: 20px;
              color: #c2fffa;
              font-family: BebasNeue;
            }
            .itlb-t{
              font-size: 14px;
              color: #c2fffa;
            }
          }
          .itlb-filter{
            height: 16px;
            width: 16px;
            background-image: url("${filterIcon}");
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: 8px;
            cursor: pointer;
            transition: all 0.25s ease-out;
          }
        }
        .it-right-box{
          display: flex;
          justify-content: flex-start;
          .irb-button{
            border: 1px solid rgb(0 229 255 / 35%);
            background-color: rgb(0 229 255 / 15%);
            border-radius: 2px;
            line-height: 22px;
            height: 24px;
            padding: 0 16px;
            font-size: 14px;
            color: #00e5ff;
            cursor: pointer;
            margin-right: 8px;
            &:last-of-type{
              margin-right: 0px;
            }
          }
        }
      }
    }
  }
`;
export const PlayerModalBoay = styled.div<ColorProps<GlobalColorPalette>>`
  position: absolute;
  .ant-modal-mask{
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0);
  }
  .ant-modal{
    width: 900px !important;
    /* height: 720px; */
    top: 50%;
    margin-top: -360px;
    padding-bottom: unset;
    .ant-modal-content{
      box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.5);
      /* border: solid 1px rgba(0, 234, 255, 0.25); */
      background-color: rgba(0, 27, 59, 0.85);
      border-radius: 0px;
      .ant-modal-header{
        background-color: rgba(0, 27, 59, 0.85);
        border-bottom-color: #00cae0;
        .ant-modal-title{
          color: #c2fffa;
        }
      }
    }
  }
  .ant-modal-body{
    padding: unset;
    .rombody{
      position: relative;
      padding: 1px 0 12px;
      .close-modal{
        position: absolute;
        right: 16px;
        top: -44px;
        height: 32px;
        width: 32px;
        cursor: pointer;
        .close-icon{
          font-size: 30px;
          color: #00cae0;
        }
      }
      .carousel-box{
        position: relative;
        height: 580px;
        padding: 16px;
      }
    }
  }
`;
export const AntdPopoverStyle = createGlobalStyle<ColorProps<GlobalColorPalette>>`
  .antd-thing-popover{
    .ant-popover-content{
      .ant-popover-arrow{
        border-bottom-color: #00cae0 !important;
        border-right-color: #00cae0 !important;
      }
      .ant-popover-inner{
        background-color: #051621;
        border-radius: 6px;
        border: 1px solid #00cae0;
        .ant-popover-inner-content{
          padding: 0;
          color: #00cae0;
        }
      }
    }
    .thing-filter{
      padding: 16px;
      .ant-checkbox-group{
        .ant-checkbox-group-item{
          display: block;
          margin-right: 0px;
        }
        .ant-checkbox-wrapper{
          color: #00cae0;
        }
      }
    }
  }
  .antecedent-tooltip {
    max-width: unset;
    z-index: 90;
    pointer-events: none;
    .ant-tooltip-content{
      pointer-events: none;
      // min-width: 100px;
      max-width: 300px;
      .ant-tooltip-inner{
        pointer-events: none;
        .prise-info-box{
          position: relative;
          .title-box-tool{
            border-bottom: 1px dashed #00cae0;
            line-height: 26px;
            font-size: 14px;
            color: #00cae0;
            // white-space: nowrap;
            &:last-of-type{
              border-bottom: none;
            }
          }
          .video-box{
            width: 100%;
            overflow: hidden;
            .carous-img{
              width: 100%;
              height: 150px;
              display: block;
            }
          }
        }
      }
    }
  }
`;
export const MarkerIcom = styled(Marker)<{colorPalette: GlobalColorPalette}>`
  position: absolute;
  transition: zIndex 0.3s ease-out;
  z-index: 1;
  &:hover{
    z-index: 5;
  }
  .maker-box{
    position: absolute;
    top: -42px;
    left: -21px;
    .icon-box{
      height: 42px;
      width: 42px;
      user-select: none;
      cursor: pointer;
      color: #00cae0;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      border-radius: 21px;
      transition: all 0.3s ease-out;
      background-color: rgb(255 123 47 / 40%);
    }
  }
  .massif-maker-box{
    position: absolute;
    top: -32px;
    left: -16px;
    .massid-spot{
      height: 32px;
      width: 32px;
      user-select: none;
      cursor: pointer;
      transition: all 0.3s ease-out;
      background-image: url("static/images/01-a.svg");
      background-repeat: no-repeat;
      background-size: contain;
      &:hover{
        background-image: url("static/images/01-b.svg");
      }
    }
  }
  .equipment-point{
    position: absolute;
    top: -24px;
    left: -12px;
    .equipment-point-icon{
      height: 24px;
      width: 24px;
      user-select: none;
      cursor: pointer;
      transition: all 0.3s ease-out;
      background-image: url("static/images/eq-a.svg");
      background-repeat: no-repeat;
      background-size: contain;
      &:hover{
        background-image: url("static/images/eq-b.svg");
      }
    }
  }
`;

export const chart2N1D: ITable<2, 1> = {
  title: "",
  subtitle: "",
  head: ["ID", "类型", "年份", "单位"],
  range: [[], [], [], []],
  prefix: ["", "", "", ""],
  suffix: ["", "", "", "亩"],
  defaultValue: [undefined, undefined, undefined, undefined],
  data: [
    ["", "耕地", "2015", 2000],
    ["", "耕地", "2016", 1000],
    ["", "耕地", "2017", 2400],
    ["", "耕地", "2018", 1600],
    ["", "耕地", "2019", 1200],
    ["", "耕地", "2020", 2800],
  ],
};
export const chart2N1DInter: ITable<2, 1> = {
  title: "",
  subtitle: "",
  head: ["ID", "类型", "公司", "单位"],
  range: [[], [], [], []],
  prefix: ["", "", "", ""],
  suffix: ["", "", "", "台"],
  defaultValue: [undefined, undefined, undefined, undefined],
  data: [
    ["", "设备", "综合智能控制箱", 2000],
    ["", "设备", "土壤水分温度传感器", 1000],
    ["", "设备", "空气温湿度传感器", 2400],
    ["", "设备", "无线光照传感器", 1600],
    ["", "设备", "二氧化碳传感器", 1200],
    ["", "设备", "土壤盐分传感器", 2800],
    ["", "设备", "智能灌溉控制器", 2800],
    ["", "设备", "固定式气象墒情综合监测站", 2800],
    ["", "设备", "土壤养分速测仪", 2800],
    ["", "设备", "农药残留测定仪", 2800],
    ["", "设备", "智能孢子捕捉仪", 2800],
    ["", "设备", "虫情信息自动采集系统", 2800],
    ["", "设备", "害虫性诱智能测报灯", 2800],
    ["", "设备", "联网风吸式杀虫灯", 2800],
    ["", "设备", "植物病害仪", 2800],
    ["", "设备", "无线水位传感器", 2800],
    ["", "设备", "无线水温传感器", 2800],
    ["", "设备", "植物营养测定仪", 2800],
    ["", "设备", "土壤水势传感器", 2800],
    ["", "设备", "土壤热通量传感器", 2800],
    ["", "设备", "无线溶解氧传感器", 2800],
    ["", "设备", "监控视频", 2800],
  ],
};

export const chart1N1DEnvi: ITable<1, 1> = {
  title: "8899",
  subtitle: "总面积(万亩)",
  head: ["ID", "类型", "面积"],
  range: [[], [], []],
  prefix: ["", "", ""],
  suffix: ["", "", "万亩"],
  defaultValue: [undefined, undefined, undefined],
  data: [
    ["", "智能孢子捕捉仪", 345],
    ["", "无线水位传感器", 567],
    ["", "植物营养测定仪", 245],
    ["", "土壤水势传感器", 145],
    ["", "土壤热通量传感器", 123],
    ["", "无线溶解氧传感器", 234],
    ["", "虫情信息自动采集系统", 123],
    ["", "害虫性诱智能测报灯", 258],
  ],
};

/** 地图类型数据列表 */
// tslint:disable:completed-docs
export const thingDataList: {label: string; value: string}[] = [
  { label: "乡村绿化", value: "乡村绿化" },
  { label: "乡村灯光", value: "乡村灯光" },
  // { label: "物联网", value: "物联网" },
];
/** 定义时间序列 */
// tslint:disable-next-line:max-file-line-count
export const datalist = ["2015", "2016", "2017", "2018", "2019"];
